<template>
  <div
    class="d-flex flex-column align-center"
    data-qa="core-selection-drawer-not-found"
  >
    <v-img
      src="/static/_v1/pd/pictures/ui-kit/search.svg"
      :alt="t('Ничего не нашлось', options)"
      width="150"
      height="150"
      class="mb-3"
    />
    <div class="text-h6 text--text mb-2">
      {{ t('Ничего не нашлось', options) }}
    </div>
    <div class="text-body-1 text-secondary--text">
      {{ t('Проверьте, нет ли ошибки в запросе', options) }}
    </div>
  </div>
</template>

<script setup lang="ts">
import I18NextVue from 'i18next'
import { computed } from 'vue'

const { t, language } = I18NextVue
const options = computed(() => ({ ns: language }))
</script>
